import React from 'react';
import Payment_Failure from '../../component/Payment_Failure';
import './style.scss';

const PaymentFailed = () =>{
    return(
        <div className='payment_failed'>
            <Payment_Failure/>
        </div>
    )
}

export default PaymentFailed;